import React, { useEffect, useMemo, useState } from "react";
import isEmpty from "lodash.isempty";
import get from "lodash.get";

import { Annotation, shop as _shop } from "config/const";
import Context from "./Context";
import { useAuth } from "providers/Auth";
import * as Client from "api/client";

const getAnnotationFns = (annotations) => {
  const findAnnotation = (key = "") =>
    annotations.find((annotation) => annotation.key === key) || {};
  const findDynamicItems = () =>
    annotations.filter(
      (annotation) =>
        !annotation.isSystem && annotation.type !== Annotation.Type.ITEM_LIST
    ) || [];
  const findItemList = () =>
    annotations.filter(
      (annotation) => annotation.type !== Annotation.Type.ITEM_LIST
    ) || {};
  const findAnnotations = (keys = []) => keys.map((key) => findAnnotation(key));
  const findPrerequisities = (key, value, isSystem = false) => {
    if (value === undefined || value === null) return [];
    return (
      annotations.filter((annotation) => {
        if (
          !annotation.prerequisities ||
          Boolean(annotation.isSystem) !== isSystem
        )
          return false;
        if (Array.isArray(annotation.prerequisities))
          return annotation.prerequisities.find((pre) => {
            const [[k, v]] = Object.entries(pre);
            return k === key && v === value;
          });
        return annotation.prerequisities[key] === value;
      }) || []
    );
  };

  return {
    findAnnotation,
    findDynamicItems,
    findItemList,
    findAnnotations,
    findPrerequisities,
  };
};

const Provider = ({ children, mock }) => {
  const [shop, setShop] = useState(isEmpty(_shop) ? mock : _shop);
  const [fetched, setFetched] = useState(false);

  const { auth } = useAuth();

  const getShop = () =>
    Client.getShop(auth.accessToken, auth.userId).then((res) => {
      if (!res.err) {
        setShop(res);
        return true;
      } else {
        return false;
      }
    });

  useEffect(() => {
    if (!auth.idToken || !auth.idToken.token || fetched) return;

    getShop().then((sState) => {
      setFetched(sState);
    });
  }, [auth]);

  const annotations = get(shop, "annotations", []);
  const {
    findAnnotation,
    findDynamicItems,
    findItemList,
    findAnnotations,
    findPrerequisities,
  } = useMemo(() => getAnnotationFns(annotations), [annotations]);

  const props = {
    shop,
    hasShop: isEmpty(shop),
    deliveryFee: get(shop, "settings.delivery_fee", {}),
    branches: get(shop, "branches", []),
    annotations,
    setShop,
    findAnnotation,
    findAnnotations,
    findPrerequisities,
    findDynamicItems,
    findItemList,
  };

  return <Context.Provider value={{ ...props }}>{children}</Context.Provider>;
};

export default Provider;
